module.exports = "<app-nav-bar></app-nav-bar>\n<mat-card class=\"pwrapper\">\n  <div>\n      <url-gen></url-gen>\n  </div>\n</mat-card>"